import type { ReactNode } from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string | ReactNode;
  children?: ReactNode;
}

export function PageHeader({ title, children }: PageHeaderProps) {
  const a11yTitle = (
    <h1 className="page-header__visually-hidden">{title}</h1>
  );

  if (children == null) {
    return a11yTitle;
  }

  return (
    <div className="page-header">
      {a11yTitle}
      <div className="page-header-actions">{children}</div>
    </div>
  );
}
